import { AppointmentI } from "@interfaces/scheduller/appointmentsI";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export const practitionerAppointments = createSlice({
    name: 'practitionerAppointments',
    initialState: {
        practitionerAppointments: []
    } as { practitionerAppointments: AppointmentI[] },
    reducers: {
        setPractitionerAppointments: (state, action: PayloadAction<{practitionerAppointments: AppointmentI[]}>) => {
            state.practitionerAppointments = action.payload.practitionerAppointments
        },
        cleanPractitionerAppointments: (state) => {
            state.practitionerAppointments.splice(0)
        },
    },
});

export const { setPractitionerAppointments, cleanPractitionerAppointments } = practitionerAppointments.actions;
export default practitionerAppointments.reducer;